import '@angular/compiler';
import { PortalLpsysadminWidgetCompanyCommentComponent } from './portal.lpsysadmin.widget.company.comment/portal.lpsysadmin.widget.company.comment.component';
import { PortalLpsysadminWidgetCompanyDataComponent } from './portal.lpsysadmin.widget.company.data/portal.lpsysadmin.widget.company.data.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalLpsysadminWidgetMessageSendComponent } from './portal.lpsysadmin.widget.message.send/portal.lpsysadmin.widget.message.send.component';
import { PortalLpsysadminWidgetNotionPageComponent } from './portal.lpsysadmin.widget.notion.page/portal.lpsysadmin.widget.notion.page.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalLpsysadminWidgetFundMemberComponent } from './portal.lpsysadmin.widget.fund.member/portal.lpsysadmin.widget.fund.member.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalLpsysadminWidgetUserProfileComponent } from './portal.lpsysadmin.widget.user.profile/portal.lpsysadmin.widget.user.profile.component';
import { PortalLpsysWidgetCompanyViewerComponent } from './portal.lpsys.widget.company.viewer/portal.lpsys.widget.company.viewer.component';
import { PortalLpsysadminWidgetFundMemberSellComponent } from './portal.lpsysadmin.widget.fund.member.sell/portal.lpsysadmin.widget.fund.member.sell.component';
import { PortalLpsysadminBoardItemComponent } from './portal.lpsysadmin.board.item/portal.lpsysadmin.board.item.component';
import { PortalLpsysadminWidgetFundInfoComponent } from './portal.lpsysadmin.widget.fund.info/portal.lpsysadmin.widget.fund.info.component';
import { PortalLpsysadminWidgetCompanyEditorComponent } from './portal.lpsysadmin.widget.company.editor/portal.lpsysadmin.widget.company.editor.component';
import { PortalLpsysadminApprovalItemComponent } from './portal.lpsysadmin.approval.item/portal.lpsysadmin.approval.item.component';
import { PortalLpsysadminDashboardComponent } from './portal.lpsysadmin.dashboard/portal.lpsysadmin.dashboard.component';
import { PortalLpsysadminUserSignatureComponent } from './portal.lpsysadmin.user.signature/portal.lpsysadmin.user.signature.component';
import { PageLogoutComponent } from './page.logout/page.logout.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageFundItemComponent } from './page.fund.item/page.fund.item.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalLpsysadminCompanyItemComponent } from './portal.lpsysadmin.company.item/portal.lpsysadmin.company.item.component';
import { PortalLpsysadminCashflowComponent } from './portal.lpsysadmin.cashflow/portal.lpsysadmin.cashflow.component';
import { PortalLpsysadminWidgetNotionCommentsComponent } from './portal.lpsysadmin.widget.notion.comments/portal.lpsysadmin.widget.notion.comments.component';
import { PageCompanyinfoComponent } from './page.companyinfo/page.companyinfo.component';
import { PortalLpsysMyprofilePasswordComponent } from './portal.lpsys.myprofile.password/portal.lpsys.myprofile.password.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalLpsysWidgetBoardComponent } from './portal.lpsys.widget.board/portal.lpsys.widget.board.component';
import { PortalLpsysadminBoardAllComponent } from './portal.lpsysadmin.board.all/portal.lpsysadmin.board.all.component';
import { PageJoinComponent } from './page.join/page.join.component';
import { PortalLpsysadminWidgetFundBoardComponent } from './portal.lpsysadmin.widget.fund.board/portal.lpsysadmin.widget.fund.board.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalLpsysadminApprovalListComponent } from './portal.lpsysadmin.approval.list/portal.lpsysadmin.approval.list.component';
import { PortalLpsysWidgetFundItemInvestmentComponent } from './portal.lpsys.widget.fund.item.investment/portal.lpsys.widget.fund.item.investment.component';
import { PortalLpsysadminWidgetCompanyOverviewComponent } from './portal.lpsysadmin.widget.company.overview/portal.lpsysadmin.widget.company.overview.component';
import { PortalLpsysCommunityViewComponent } from './portal.lpsys.community.view/portal.lpsys.community.view.component';
import { PortalLpsysFundItemComponent } from './portal.lpsys.fund.item/portal.lpsys.fund.item.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalLpsysadminApprovalTemplateComponent } from './portal.lpsysadmin.approval.template/portal.lpsysadmin.approval.template.component';
import { PortalLpsysadminFundItemComponent } from './portal.lpsysadmin.fund.item/portal.lpsysadmin.fund.item.component';
import { PortalLpsysFundListFormedComponent } from './portal.lpsys.fund.list.formed/portal.lpsys.fund.list.formed.component';
import { PortalLpsysWidgetFundItemInfoComponent } from './portal.lpsys.widget.fund.item.info/portal.lpsys.widget.fund.item.info.component';
import { PortalLpsysadminWidgetCompanyProductComponent } from './portal.lpsysadmin.widget.company.product/portal.lpsysadmin.widget.company.product.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PageFindpwComponent } from './page.findpw/page.findpw.component';
import { PortalLpsysMyprofileEditComponent } from './portal.lpsys.myprofile.edit/portal.lpsys.myprofile.edit.component';
import { PortalLpsysadminWidgetCompanyBoardComponent } from './portal.lpsysadmin.widget.company.board/portal.lpsysadmin.widget.company.board.component';
import { PageMyprofileComponent } from './page.myprofile/page.myprofile.component';
import { PortalLpsysadminFundListFormedComponent } from './portal.lpsysadmin.fund.list.formed/portal.lpsysadmin.fund.list.formed.component';
import { PageCommunityComponent } from './page.community/page.community.component';
import { PortalLpsysFundListOperatingComponent } from './portal.lpsys.fund.list.operating/portal.lpsys.fund.list.operating.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalLpsysCommunityBoardComponent } from './portal.lpsys.community.board/portal.lpsys.community.board.component';
import { PortalLpsysWidgetFundItemDocsComponent } from './portal.lpsys.widget.fund.item.docs/portal.lpsys.widget.fund.item.docs.component';
import { PortalLpsysadminWidgetCompanyLogComponent } from './portal.lpsysadmin.widget.company.log/portal.lpsysadmin.widget.company.log.component';
import { PortalLpsysCompanyItemComponent } from './portal.lpsys.company.item/portal.lpsys.company.item.component';
import { PortalLpsysFundListExitComponent } from './portal.lpsys.fund.list.exit/portal.lpsys.fund.list.exit.component';
import { PortalLpsysMyprofileInfoComponent } from './portal.lpsys.myprofile.info/portal.lpsys.myprofile.info.component';
import { PortalLpsysMyprofileDeductionComponent } from './portal.lpsys.myprofile.deduction/portal.lpsys.myprofile.deduction.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalLpsysadminCalendarComponent } from './portal.lpsysadmin.calendar/portal.lpsysadmin.calendar.component';
import { PortalLpsysadminUserListComponent } from './portal.lpsysadmin.user.list/portal.lpsysadmin.user.list.component';
import { PortalLpsysadminFundListOperationComponent } from './portal.lpsysadmin.fund.list.operation/portal.lpsysadmin.fund.list.operation.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalLpsysadminCompanyListComponent } from './portal.lpsysadmin.company.list/portal.lpsysadmin.company.list.component';
import { PortalLpsysadminWidgetFundInviteComponent } from './portal.lpsysadmin.widget.fund.invite/portal.lpsysadmin.widget.fund.invite.component';
import { PortalLpsysadminWidgetFundDocumentComponent } from './portal.lpsysadmin.widget.fund.document/portal.lpsysadmin.widget.fund.document.component';
import { PortalLpsysadminFundListExitComponent } from './portal.lpsysadmin.fund.list.exit/portal.lpsysadmin.fund.list.exit.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PageCompanyItemComponent } from './page.company.item/page.company.item.component';
import { PortalLpsysadminWidgetFundInvestmentComponent } from './portal.lpsysadmin.widget.fund.investment/portal.lpsysadmin.widget.fund.investment.component';
import { PortalLpsysWidgetPdfviewerComponent } from './portal.lpsys.widget.pdfviewer/portal.lpsys.widget.pdfviewer.component';
import { PortalLpsysadminSystemDashboardComponent } from './portal.lpsysadmin.system.dashboard/portal.lpsysadmin.system.dashboard.component';
import { PortalLpsysadminWidgetNotionEditorComponent } from './portal.lpsysadmin.widget.notion.editor/portal.lpsysadmin.widget.notion.editor.component';
import { PortalLpsysadminWidgetCompanyInfoComponent } from './portal.lpsysadmin.widget.company.info/portal.lpsysadmin.widget.company.info.component';
import { PortalLpsysadminTodoComponent } from './portal.lpsysadmin.todo/portal.lpsysadmin.todo.component';
import { PortalLpsysadminBoardListComponent } from './portal.lpsysadmin.board.list/portal.lpsysadmin.board.list.component';
import { PortalLpsysWidgetCompanyProductComponent } from './portal.lpsys.widget.company.product/portal.lpsys.widget.company.product.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";

@NgModule({
    declarations: [
        AppComponent,
        PortalLpsysadminWidgetCompanyCommentComponent,
        PortalLpsysadminWidgetCompanyDataComponent,
        PortalSeasonLoadingHexaComponent,
        PortalLpsysadminWidgetMessageSendComponent,
        PortalLpsysadminWidgetNotionPageComponent,
        ComponentNavSidebarComponent,
        PortalLpsysadminWidgetFundMemberComponent,
        PortalSeasonLoadingComponent,
        PortalSeasonTabComponent,
        PortalLpsysadminWidgetUserProfileComponent,
        PortalLpsysWidgetCompanyViewerComponent,
        PortalLpsysadminWidgetFundMemberSellComponent,
        PortalLpsysadminBoardItemComponent,
        PortalLpsysadminWidgetFundInfoComponent,
        PortalLpsysadminWidgetCompanyEditorComponent,
        PortalLpsysadminApprovalItemComponent,
        PortalLpsysadminDashboardComponent,
        PortalLpsysadminUserSignatureComponent,
        PageLogoutComponent,
        PortalSeasonLoadingSeasonComponent,
        PageFundItemComponent,
        PortalSeasonStatusbarComponent,
        PortalLpsysadminCompanyItemComponent,
        PortalLpsysadminCashflowComponent,
        PortalLpsysadminWidgetNotionCommentsComponent,
        PageCompanyinfoComponent,
        PortalLpsysMyprofilePasswordComponent,
        LayoutNavbarComponent,
        PortalLpsysWidgetBoardComponent,
        PortalLpsysadminBoardAllComponent,
        PageJoinComponent,
        PortalLpsysadminWidgetFundBoardComponent,
        LayoutSidebarComponent,
        PortalLpsysadminApprovalListComponent,
        PortalLpsysWidgetFundItemInvestmentComponent,
        PortalLpsysadminWidgetCompanyOverviewComponent,
        PortalLpsysCommunityViewComponent,
        PortalLpsysFundItemComponent,
        PortalSeasonUiDropdownComponent,
        PortalLpsysadminApprovalTemplateComponent,
        PortalLpsysadminFundItemComponent,
        PortalLpsysFundListFormedComponent,
        PortalLpsysWidgetFundItemInfoComponent,
        PortalLpsysadminWidgetCompanyProductComponent,
        PortalSeasonAlertComponent,
        PortalSeasonViewerTreeComponent,
        PageFindpwComponent,
        PortalLpsysMyprofileEditComponent,
        PortalLpsysadminWidgetCompanyBoardComponent,
        PageMyprofileComponent,
        PortalLpsysadminFundListFormedComponent,
        PageCommunityComponent,
        PortalLpsysFundListOperatingComponent,
        PortalSeasonPaginationComponent,
        PortalLpsysCommunityBoardComponent,
        PortalLpsysWidgetFundItemDocsComponent,
        PortalLpsysadminWidgetCompanyLogComponent,
        PortalLpsysCompanyItemComponent,
        PortalLpsysFundListExitComponent,
        PortalLpsysMyprofileInfoComponent,
        PortalLpsysMyprofileDeductionComponent,
        PageAdminComponent,
        PortalLpsysadminCalendarComponent,
        PortalLpsysadminUserListComponent,
        PortalLpsysadminFundListOperationComponent,
        LayoutEmptyComponent,
        PortalLpsysadminCompanyListComponent,
        PortalLpsysadminWidgetFundInviteComponent,
        PortalLpsysadminWidgetFundDocumentComponent,
        PortalLpsysadminFundListExitComponent,
        PageLoginComponent,
        PageCompanyItemComponent,
        PortalLpsysadminWidgetFundInvestmentComponent,
        PortalLpsysWidgetPdfviewerComponent,
        PortalLpsysadminSystemDashboardComponent,
        PortalLpsysadminWidgetNotionEditorComponent,
        PortalLpsysadminWidgetCompanyInfoComponent,
        PortalLpsysadminTodoComponent,
        PortalLpsysadminBoardListComponent,
        PortalLpsysWidgetCompanyProductComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        SortablejsModule,
        
    ],
    providers: [{
        provide: COMPOSITION_BUFFER_MODE,
        useValue: false
    }],
    bootstrap: [AppComponent]
})
export class AppModule { }